import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const similarItemsGroupsRootSelector = createSelector(stateSelector, (s) => s.similarItemsGroups);

const byIdSelector = createSelector(similarItemsGroupsRootSelector, (s) => s.byId);
const loadedSelector = createSelector(similarItemsGroupsRootSelector, (s) => s.loaded);
const loadingSelector = createSelector(similarItemsGroupsRootSelector, (s) => s.loading);
const totalRecordsByItemIdSelector = createSelector(similarItemsGroupsRootSelector, (s) => s.totalRecordsByItemId);

const itemIdSelector = (_: GlobalState, itemId: number) => itemId;

export const getSimilarItemsGroupsItemIds = createSelector(
    [byIdSelector, itemIdSelector],
    (byId, itemId) => byId[itemId] ?? []
);

export const getIsSimilarItemsGroupsLoading = createSelector([loadingSelector, itemIdSelector], (loading, itemId) =>
    loading.includes(itemId)
);

export const getHasSimilarItemsGroupsFetchCompleted = createSelector(
    [loadedSelector, itemIdSelector],
    (loaded, itemId) => loaded[itemId] !== undefined
);

export const getSimilarItemsGroupsTotalRecords = createSelector(
    [totalRecordsByItemIdSelector, itemIdSelector],
    (totalRecordsByItemId, itemId) => totalRecordsByItemId[itemId] ?? 0
);
